var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpened(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.941 7.81067C15.815 7.62732 12.7869 3.33325 8.00021 3.33325C3.8928 3.33325 0.23274 7.60266 0.0787376 7.78466C-0.0259203 7.90867 -0.0259203 8.09067 0.0787376 8.21533C0.23274 8.39733 3.8928 12.6667 8.00021 12.6667C12.1076 12.6667 15.7676 8.39733 15.9216 8.21533C16.0183 8.10067 16.027 7.93467 15.941 7.81067ZM8.00021 12.0001C4.7075 12.0001 1.57676 8.86002 0.781436 8.00001C1.57545 7.13934 4.70284 3.99995 8.00021 3.99995C11.8529 3.99995 14.5723 7.13534 15.2363 7.98201C14.4696 8.81468 11.3209 12.0001 8.00021 12.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 5.33325C6.52927 5.33325 5.33325 6.52927 5.33325 7.99996C5.33325 9.47064 6.52927 10.6667 7.99996 10.6667C9.47064 10.6667 10.6667 9.47064 10.6667 7.99996C10.6667 6.52927 9.47064 5.33325 7.99996 5.33325ZM7.99996 10C6.89728 10 5.99992 9.10267 5.99992 7.99999C5.99992 6.89731 6.89728 5.99995 7.99996 5.99995C9.10263 5.99995 9.99999 6.89731 9.99999 7.99999C9.99999 9.10267 9.10263 10 7.99996 10Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpened);
export default __webpack_public_path__ + "static/media/eye_opened.210d2420.svg";
export { ForwardRef as ReactComponent };